/**
 * Created by ubuntuuser on 18-9-10.
 */
import axios from 'axios'
import router from '../router/index'
import querystring from 'querystring'

axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.interceptors.response.use(
  response => {
    if (response.data.c === -2010 || response.data.c === -2002) {
      router.push({ path: '/login' })
    }
    return response
  }
)

const base = 'http://leaflet-api.jituia.com'

// const base = 'http://127.0.0.1:5000'

export const login = params => { return axios.post(`${base}/auth/login`, querystring.stringify(params)) }// 登录

export const logout = params => {
  return axios.get(`${base}/auth/logout`, {params: params})
}

export const uploadImage = params => { return axios.post(`${base}/admin/base/upload_image`, querystring.stringify(params)) }// 公众号头像上传接口协议

// export const uploadHeadimg = params => { return axios.post(`${base}/admin/app/upload_headimg`, querystring.stringify(params)) }// 公众号头像上传接口协议

// export const uploadImg = params => { return axios.post(`${base}/admin/base/upload_image`, querystring.stringify(params)) }// 公众号上传图片

export const getMarketDetail = params => { return axios.get(`${base}/admin/market/get_market_detail`, { params: params }) }// 获取业务详情接口协议

export const marketEdit = params => { return axios.post(`${base}/admin/market/market_edit`, querystring.stringify(params)) }// 业务表编辑协议

export const editUserInfo = params => { return axios.post(`${base}/admin/bbj/edit_user_info`, querystring.stringify(params)) }// 公众号上传图片

export const userEdit = params => { return axios.post(`${base}/admin/user/user_edit`, querystring.stringify(params)) }// 公众号上传图片

export const imageUpload = params => { return axios.post(`${base}/admin/base/image_upload`, querystring.stringify(params)) }// 公众号上传图片

export const adBase = params => { return axios.get(`${base}/admin/aver/base`, { params: params }) }// 抽奖详情协议

export const adDayBase = params => { return axios.get(`${base}/admin/aver/day_base`, { params: params }) }// 抽奖详情协议

export const adPeriodDayBase = params => { return axios.get(`${base}/admin/aver/period_day_base`, { params: params }) }// 抽奖详情协议

export const adPeriodDayBudget = params => { return axios.get(`${base}/admin/aver/period_day_budget`, { params: params }) }// 抽奖详情协议

export const adDayBudget = params => { return axios.get(`${base}/admin/aver/day_budget`, { params: params }) }// 抽奖详情协议

export const adConciseLists = params => { return axios.get(`${base}/admin/aver/ad_concise_lists`, { params: params }) }// 抽奖详情协议

export const adLists = params => { return axios.get(`${base}/admin/aver/ad_lists`, { params: params }) }// 抽奖详情协议
export const adMonthLists = params => { return axios.get(`${base}/admin/aver/ad_month_lists`, { params: params }) }// 抽奖详情协议
export const adMonthSummary = params => { return axios.get(`${base}/admin/aver/ad_month_summary`, { params: params }) }// 抽奖详情协议

export const dsMonthSummary = params => { return axios.get(`${base}/admin/aver/ds_month_summary`, { params: params }) }// 抽奖详情协议

export const dsMonthData = params => { return axios.get(`${base}/admin/aver/ds_month_data`, { params: params }) }// 抽奖详情协议

export const dsMonthEdit = params => { return axios.post(`${base}/admin/aver/ds_month_edit`, querystring.stringify(params)) }// 公众号上传图片

export const downloadAdMonthLists = base + '/admin/aver/ad_month_lists'

export const downloadDsMonthSummary = base + '/admin/aver/ds_month_summary'

export const downloadDsMonthData = base + '/admin/aver/ds_month_data'

export const downloadDsAdDetail = base + '/admin/aver/ds_ad_detail'

export const adOrderLists = params => { return axios.get(`${base}/admin/aver/order_lists`, { params: params }) }// 抽奖详情协议

export const adOrderUpdate = params => { return axios.post(`${base}/admin/aver/order_update`, querystring.stringify(params)) }// 公众号上传图片

export const adStat = params => { return axios.get(`${base}/admin/aver/ad_stat`, { params: params }) }// 抽奖详情协议

export const adUserLists = params => { return axios.get(`${base}/admin/user/user_lists`, { params: params }) }// 抽奖详情协议

// export const userEdit = params => { return axios.post(`${base}/admin/user/user_edit`, querystring.stringify(params)) }// 公众号上传图片

export const adExchangeLists = params => { return axios.get(`${base}/admin/aver/exchange_lists`, { params: params }) }// 抽奖详情协议

export const adExchangeUpdate = params => { return axios.post(`${base}/admin/aver/exchange_update`, querystring.stringify(params)) }// 公众号上传图片

export const adExchangeEdit = params => { return axios.post(`${base}/admin/aver/exchange_edit`, querystring.stringify(params)) }// 公众号上传图片

export const adMultiExchangeUpdate = params => { return axios.post(`${base}/admin/aver/multi_exchange_update`, querystring.stringify(params)) }// 公众号上传图片

export const downloadAverPersonMultiExchange = base + '/admin/aver/download_person_multi_exchange'

export const averExchangeUpload = params => {
  return axios.post(`${base}/admin/aver/aver_exchange_upload`, params, {headers: {'Content-Type': 'multipart/form-data'}})
}

export const adEdit = params => { return axios.post(`${base}/admin/aver/ad_edit`, querystring.stringify(params)) }// 公众号上传图片

export const adDetail = params => { return axios.get(`${base}/admin/aver/ad_detail`, { params: params }) }// 抽奖详情协议

export const adUserDetail = params => { return axios.get(`${base}/admin/user/user_detail`, { params: params }) }// 抽奖详情协议

export const adOrderUserLists = params => { return axios.get(`${base}/admin/user/order_user_lists`, { params: params }) }// 抽奖详情协议

export const adUserAdLists = params => { return axios.get(`${base}/admin/user/user_ad_lists`, { params: params }) }// 抽奖详情协议

export const adUserConfEdit = params => { return axios.post(`${base}/admin/aver_user/ad_user_conf_edit`, querystring.stringify(params)) }// 广告用户配置

export const adUserConfLists = params => { return axios.get(`${base}/admin/aver_user/ad_user_conf_lists`, { params: params }) }// 广告用户配置列表

export const aderLists = params => { return axios.get(`${base}/admin/aver/ader_lists`, { params: params }) }// 抽奖详情协议

export const aderEdit = params => { return axios.post(`${base}/admin/aver/ader_edit`, querystring.stringify(params)) }// 编辑

export const adRegisterEdit = params => { return axios.post(`${base}/admin/aver/ad_register_edit`, querystring.stringify(params)) }// 广告用户配置

export const adRegisterLists = params => { return axios.get(`${base}/admin/aver/ad_register_lists`, { params: params }) }// 广告用户配置列表

export const adPredictEdit = params => { return axios.post(`${base}/admin/aver/ad_predict_edit`, querystring.stringify(params)) }// 广告用户配置

export const adPredictLists = params => { return axios.get(`${base}/admin/aver/ad_predict_lists`, { params: params }) }// 广告用户配置列表

export const downloadAdPredictLists = base + '/admin/aver/ad_predict_download'

// export const adBusinessEdit = params => { return axios.post(`${base}/admin/aver/ad_business_edit`, querystring.stringify(params)) }// 公众号上传图片

// export const adBusinessLists = params => { return axios.get(`${base}/admin/aver/ad_business_lists`, { params: params }) }// 抽奖详情协议

export const adOrderDetail = params => { return axios.get(`${base}/admin/aver/order_detail`, { params: params }) }// 抽奖详情协议

export const adOrderEdit = params => { return axios.post(`${base}/admin/aver/order_edit`, querystring.stringify(params)) }// 公众号上传图片

export const adOrderMultiUpdate = params => { return axios.post(`${base}/admin/aver/order_multi_update`, querystring.stringify(params)) }// 公众号上传图片

export const adOrderMultiRemarkUpdate = params => { return axios.post(`${base}/admin/aver/order_multi_remark_update`, querystring.stringify(params)) }// 公众号上传图片

export const adOrderMultiReceiveUpdate = params => {
  return axios.post(`${base}/admin/aver/order_multi_receive_update`, params, {headers: {'Content-Type': 'multipart/form-data'}})
}// 公众号上传图片

export const orderMultiRevise = params => { return axios.post(`${base}/admin/aver/order_multi_revise`, querystring.stringify(params)) }// 公众号上传图片

export const adOrderExpressLists = params => { return axios.get(`${base}/admin/aver/order_express_lists`, { params: params }) }// 抽奖详情协议

export const adOrderExpressEdit = params => { return axios.post(`${base}/admin/aver/order_express_edit`, querystring.stringify(params)) }// 公众号上传图片

export const queryExpressTrack = params => { return axios.get(`${base}/admin/aver/query_express_track`, { params: params }) }// 抽奖详情协议

export const adOrderDownload = params => { return axios.get(`${base}/admin/aver/order_download`, { params: params }) }// 订单下载

export const downloadAdOrderLists = base + '/admin/aver/order_download'

export const summaryOrderExchange = params => { return axios.get(`${base}/admin/aver/summary_order_exchange`, { params: params }) }// 汇总订单生成兑换记录

export const summaryAdDsData = params => { return axios.get(`${base}/admin/aver/summary_ds_data`, { params: params }) }// 汇总每月数据

export const adWatchwordLists = params => { return axios.get(`${base}/admin/aver/ad_watchword_lists`, { params: params }) }// 抽奖详情协议

export const adWatchwordEdit = params => { return axios.post(`${base}/admin/aver/ad_watchword_edit`, querystring.stringify(params)) }// 公众号上传图片

export const adWatchwordDetail = params => { return axios.get(`${base}/admin/aver/ad_watchword_detail`, { params: params }) }// 抽奖详情协议

export const adChnLists = params => { return axios.get(`${base}/admin/aver/ad_chn_lists`, { params: params }) }// 抽奖详情协议

export const adChnEdit = params => { return axios.post(`${base}/admin/aver/ad_chn_edit`, querystring.stringify(params)) }// 编辑

export const adChnAddressEdit = params => { return axios.post(`${base}/admin/aver/ad_chn_address_edit`, querystring.stringify(params)) }// 编辑

export const adChnAddressLists = params => { return axios.get(`${base}/admin/aver/ad_chn_address_lists`, { params: params }) }// 抽奖详情协议

export const operLists = params => { return axios.get(`${base}/admin/oper/oper_lists`, { params: params }) }// 抽奖详情协议

export const dyKeywordLists = params => { return axios.get(`${base}/admin/aver/dy_keyword_lists`, { params: params }) }// 抽奖详情协议

export const dyKeywordUpload = params => {
  return axios.post(`${base}/admin/aver/dy_keyword_upload`, params, {headers: {'Content-Type': 'multipart/form-data'}})
}

export const chnDockingLists = params => { return axios.get(`${base}/admin/chn/docking_lists`, { params: params }) }// 抽奖详情协议

export const chnDockingEdit = params => { return axios.post(`${base}/admin/chn/docking_edit`, querystring.stringify(params)) }// 公众号上传图片

export const ledgerLists = params => { return axios.get(`${base}/admin/finance/ledger_lists`, { params: params }) }// 抽奖详情协议

export const ledgerEdit = params => { return axios.post(`${base}/admin/finance/ledger_edit`, querystring.stringify(params)) }// 公众号上传图片

export const ledgerDetail = params => { return axios.get(`${base}/admin/finance/ledger_detail`, { params: params }) }// 抽奖详情协议

export const ledgerRecordLists = params => { return axios.get(`${base}/admin/finance/ledger_record_lists`, { params: params }) }// 抽奖详情协议

export const ledgerRecordEdit = params => { return axios.post(`${base}/admin/finance/ledger_record_edit`, querystring.stringify(params)) }// 公众号上传图片

export const ledgerRecordUpload = params => {
  return axios.post(`${base}/admin/finance/ledger_record_upload`, params, {headers: {'Content-Type': 'multipart/form-data'}})
}

export const ledgerMultiReceiveUpdate = params => {
  return axios.post(`${base}/admin/finance/ledger_multi_receive_update`, params, {headers: {'Content-Type': 'multipart/form-data'}})
}// 公众号上传图片

export const ledgerExpressUpload = params => {
  return axios.post(`${base}/admin/finance/ledger_express_upload`, params, {headers: {'Content-Type': 'multipart/form-data'}})
}

export const ledgerMultiReceiveCreate = params => { return axios.post(`${base}/admin/finance/ledger_multi_receive_create`, querystring.stringify(params)) }// 公众号上传图片

export const downloadLedgerLists = base + '/admin/finance/ledger_lists'

export const invoiceTitleLists = params => { return axios.get(`${base}/admin/finance/invoice_title_lists`, { params: params }) }// 抽奖详情协议

export const invoiceTitleEdit = params => { return axios.post(`${base}/admin/finance/invoice_title_edit`, querystring.stringify(params)) }// 公众号上传图片

export const sjLists = params => { return axios.get(`${base}/admin/sj/sj_lists`, { params: params }) }// 抽奖详情协议

export const sjEdit = params => { return axios.post(`${base}/admin/sj/sj_edit`, querystring.stringify(params)) }// 公众号上传图片

export const sjDetail = params => { return axios.get(`${base}/admin/sj/sj_detail`, { params: params }) }// 抽奖详情协议

export const inboundEdit = params => { return axios.post(`${base}/admin/stock/inbound_edit`, querystring.stringify(params)) }// 入库编辑

export const inboundDetail = params => { return axios.get(`${base}/admin/stock/inbound_detail`, { params: params }) }// 入库详情

export const inboundLists = params => { return axios.get(`${base}/admin/stock/inbound_lists`, { params: params }) }// 入库列表

export const outboundEdit = params => { return axios.post(`${base}/admin/stock/outbound_edit`, querystring.stringify(params)) }// 出库编辑

export const outboundDetail = params => { return axios.get(`${base}/admin/stock/outbound_detail`, { params: params }) }// 出库详情

export const outboundLists = params => { return axios.get(`${base}/admin/stock/outbound_lists`, { params: params }) }// 出库列表

export const stockLists = params => { return axios.get(`${base}/admin/stock/stock_lists`, { params: params }) }// 库存列表

export const shopCategoryLists = params => { return axios.get(`${base}/admin/shop/get_category_lists`, { params: params }) }// 抽奖详情协议

export const shopCategoryEdit = params => { return axios.post(`${base}/admin/shop/category_edit`, querystring.stringify(params)) }// 编辑

export const shopBannerLists = params => { return axios.get(`${base}/admin/shop/get_banner_lists`, { params: params }) }// 抽奖详情协议

export const shopBannerEdit = params => { return axios.post(`${base}/admin/shop/banner_edit`, querystring.stringify(params)) }// 编辑

export const shopFeatureCategoryLists = params => { return axios.get(`${base}/admin/shop/get_feature_category_lists`, { params: params }) }// 抽奖详情协议

export const shopFeatureCategoryEdit = params => { return axios.post(`${base}/admin/shop/feature_category_edit`, querystring.stringify(params)) }// 编辑

export const shopFeatureAttributeMultiCreate = params => { return axios.post(`${base}/admin/shop/feature_attribute_multi_create`, querystring.stringify(params)) }// 编辑

export const shopFeatureAttributeLists = params => { return axios.get(`${base}/admin/shop/get_feature_attribute_lists`, { params: params }) }// 抽奖详情协议

export const shopFeatureAttributeEdit = params => { return axios.post(`${base}/admin/shop/feature_attribute_edit`, querystring.stringify(params)) }// 编辑

export const shopGoodsLists = params => { return axios.get(`${base}/admin/shop/get_goods_lists`, { params: params }) }// 抽奖详情协议

export const shopGoodsEdit = params => { return axios.post(`${base}/admin/shop/shop_goods_edit`, querystring.stringify(params)) }// 公众号上传图片

export const shopGoodsStockLists = params => { return axios.get(`${base}/admin/shop/get_goods_stock_lists`, { params: params }) }// 抽奖详情协议

export const shopGoodsStockFullLists = params => { return axios.get(`${base}/admin/shop/get_goods_stock_full_lists`, { params: params }) }// 抽奖详情协议

export const shopGoodsStockEdit = params => { return axios.post(`${base}/admin/shop/goods_stock_edit`, querystring.stringify(params)) }// 公众号上传图片

export const shopGoodsDetail = params => { return axios.get(`${base}/admin/shop/get_goods_detail`, { params: params }) }// 抽奖详情协议

export const shopOrderLists = params => { return axios.get(`${base}/admin/shop/get_order_lists`, { params: params }) }// 抽奖详情协议

export const shopOrderEdit = params => { return axios.post(`${base}/admin/shop/shop_order_edit`, querystring.stringify(params)) }// 公众号上传图片

export const shopOrderGoodsLists = params => { return axios.get(`${base}/admin/shop/get_order_goods_lists`, { params: params }) }// 抽奖详情协议

export const shopOrderGoodsEdit = params => { return axios.post(`${base}/admin/shop/shop_order_goods_edit`, querystring.stringify(params)) }// 公众号上传图片

export const shopUserLists = params => { return axios.get(`${base}/admin/shop/get_user_lists`, { params: params }) }// 抽奖详情协议

export const shopOrderPayLists = params => { return axios.get(`${base}/admin/shop/get_order_pay_lists`, { params: params }) }// 抽奖详情协议

export const shopUserEdit = params => { return axios.post(`${base}/admin/shop/shop_user_edit`, querystring.stringify(params)) }// 公众号上传图片

export const shopChnUserLists = params => { return axios.get(`${base}/admin/shop/get_chn_user_lists`, { params: params }) }// 抽奖详情协议

export const shopChnUserEdit = params => { return axios.post(`${base}/admin/shop/chn_user_edit`, querystring.stringify(params)) }// 公众号上传图片

export const shopExchangeLists = params => { return axios.get(`${base}/admin/shop/exchange_lists`, { params: params }) }// 抽奖详情协议

export const shopExchangeUpdate = params => { return axios.post(`${base}/admin/shop/exchange_update`, querystring.stringify(params)) }// 公众号上传图片

export const downloadShopOrderGoods = base + '/admin/shop/get_order_goods_lists'

export const shopOrderGoodsUpload = params => {
  return axios.post(`${base}/admin/shop/order_goods_upload`, params, {headers: {'Content-Type': 'multipart/form-data'}})
}// 公众号上传图片

export const getCardList = params => {
  return axios.get(`${base}/admin/market/get_market_card`, {params: params})
}// 获取专属名片列表接口协议

export const getCardDetail = params => {
  return axios.get(`${base}/admin/market/get_market_card_detail`, {params: params})
}// 获取专属名片详情接口协议

export const cardEdit = params => {
  return axios.post(`${base}/admin/market/market_card_edit`, querystring.stringify(params))
}// 专属名片编辑或新建接口协议

export const earnBase = params => { return axios.get(`${base}/admin/earn/base`, { params: params }) }// 抽奖详情协议

export const earnDayBase = params => { return axios.get(`${base}/admin/earn/day_base`, { params: params }) }// 抽奖详情协议

export const earnPeriodDayBase = params => { return axios.get(`${base}/admin/earn/period_day_base`, { params: params }) }// 抽奖详情协议

export const taskLists = params => { return axios.get(`${base}/admin/earn/task_lists`, { params: params }) }// 抽奖详情协议

export const taskEdit = params => { return axios.post(`${base}/admin/earn/task_edit`, querystring.stringify(params)) }// 公众号上传图片

export const taskDetail = params => { return axios.get(`${base}/admin/earn/task_detail`, { params: params }) }// 抽奖详情协议

export const earnUserLists = params => { return axios.get(`${base}/admin/earn/earn_user_lists`, { params: params }) }// 抽奖详情协议

export const earnUserEdit = params => { return axios.post(`${base}/admin/earn/earn_user_edit`, querystring.stringify(params)) }// 公众号上传图片

export const earnUserDetail = params => { return axios.get(`${base}/admin/earn/earn_user_detail`, { params: params }) }// 抽奖详情协议

export const earnUserTaskRecordLists = params => { return axios.get(`${base}/admin/earn/user_task_record_lists`, { params: params }) }// 抽奖详情协议

export const earnOrderLists = params => { return axios.get(`${base}/admin/earn/earn_order_lists`, { params: params }) }// 抽奖详情协议

export const earnOrderEdit = params => { return axios.post(`${base}/admin/earn/earn_order_edit`, querystring.stringify(params)) }// 公众号上传图片

export const earnOrderDetail = params => { return axios.get(`${base}/admin/earn/earn_order_detail`, { params: params }) }// 抽奖详情协议

export const earnOrderUpdate = params => { return axios.post(`${base}/admin/earn/earn_order_update`, querystring.stringify(params)) }// 公众号上传图片

export const earnOrderMultiUpdate = params => { return axios.post(`${base}/admin/earn/earn_order_multi_update`, querystring.stringify(params)) }// 公众号上传图片

export const earnOrderInvoiceUpdate = params => { return axios.post(`${base}/admin/earn/earn_order_invoice_update`, querystring.stringify(params)) }// 公众号上传图片

export const earnOrderMultiRevise = params => { return axios.post(`${base}/admin/earn/earn_order_multi_revise`, querystring.stringify(params)) }// 公众号上传图片

export const downloadEarnOrderLists = base + '/admin/earn/earn_order_download'

export const earnExchangeLists = params => { return axios.get(`${base}/admin/earn/earn_exchange_lists`, { params: params }) }// 抽奖详情协议

export const earnExchangeUpdate = params => { return axios.post(`${base}/admin/earn/earn_exchange_update`, querystring.stringify(params)) }// 公众号上传图片

export const earnExchangeEdit = params => { return axios.post(`${base}/admin/earn/earn_exchange_edit`, querystring.stringify(params)) }// 公众号上传图片

export const earnMultiExchangeUpdate = params => { return axios.post(`${base}/admin/earn/earn_multi_exchange_update`, querystring.stringify(params)) }// 公众号上传图片

export const downloadEarnExchangeLists = base + '/admin/earn/earn_exchange_lists'

export const earnExchangeUpload = params => {
  return axios.post(`${base}/admin/earn/earn_exchange_upload`, params, {headers: {'Content-Type': 'multipart/form-data'}})
}

export const earnPersonMultiExchange = params => { return axios.post(`${base}/admin/earn/earn_person_multi_exchange`, querystring.stringify(params)) }// 公众号上传图片

export const downloadPersonMultiExchange = base + '/admin/earn/download_person_multi_exchange'

export const earnSummaryOrderExchange = params => { return axios.get(`${base}/admin/earn/summary_order_exchange`, { params: params }) }// 汇总订单生成兑换记录

export const earnKttOrderLists = params => { return axios.get(`${base}/admin/earn/ktt_order_lists`, { params: params }) }// 抽奖详情协议

export const kttOrderUpload = params => {
  return axios.post(`${base}/admin/earn/ktt_order_upload`, params, {headers: {'Content-Type': 'multipart/form-data'}})
}

export const earnRequestLists = params => { return axios.get(`${base}/admin/earn/http_request_lists`, { params: params }) }// 抽奖详情协议

export const earnRequestEdit = params => { return axios.post(`${base}/admin/earn/http_request_edit`, querystring.stringify(params)) }// 公众号上传图片

export const earnResponseLists = params => { return axios.get(`${base}/admin/earn/http_response_lists`, { params: params }) }// 抽奖详情协议

export const earnResponseEdit = params => { return axios.post(`${base}/admin/earn/http_response_edit`, querystring.stringify(params)) }// 公众号上传图片

export const earnExpressLists = params => { return axios.get(`${base}/admin/earn/express_lists`, { params: params }) }// 抽奖详情协议

export const earnExpressEdit = params => { return axios.post(`${base}/admin/earn/express_edit`, querystring.stringify(params)) }// 公众号上传图片

// manage
export const operEdit = params => { return axios.post(`${base}/admin/oper/oper_edit`, querystring.stringify(params)) }// 编辑

export const operRoleLists = params => { return axios.get(`${base}/admin/oper/oper_role_lists`, { params: params }) }// 抽奖详情协议



// WEBPACK FOOTER //
// ./src/api/api.js